import axios from 'axios';
import BaseAPI from './base/base-api';

class CertificateAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'certificate';

}

export default new CertificateAPI();